import React from 'react';

interface UserGroupIconProps {
  className?: string;
  color?: string;
  size?: number;
}

const UserGroupIcon: React.FC<UserGroupIconProps> = ({
  className = '',
  color = '#A2876E',
  size = 24,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path
        d="M18.1072 8.41002C18.0772 8.41002 18.0572 8.41002 18.0272 8.41002H17.9772C16.0872 8.35002 14.6772 6.89001 14.6772 5.09001C14.6772 3.25001 16.1772 1.76001 18.0072 1.76001C19.8372 1.76001 21.3372 3.26001 21.3372 5.09001C21.3272 6.90001 19.9172 8.36001 18.1172 8.42001C18.1172 8.41001 18.1172 8.41002 18.1072 8.41002ZM18.0072 3.25002C16.9972 3.25002 16.1772 4.07002 16.1772 5.08002C16.1772 6.07002 16.9472 6.87002 17.9372 6.91002C17.9472 6.90002 18.0272 6.90002 18.1172 6.91002C19.0872 6.86002 19.8372 6.06002 19.8472 5.08002C19.8472 4.07002 19.0272 3.25002 18.0072 3.25002Z"
        fill="#6D6E7A"
      />
      <path
        d="M18.1174 15.78C17.7274 15.78 17.3374 15.75 16.9474 15.68C16.5374 15.61 16.2674 15.22 16.3374 14.81C16.4074 14.4 16.7974 14.13 17.2074 14.2C18.4374 14.41 19.7374 14.18 20.6074 13.6C21.0774 13.29 21.3274 12.9 21.3274 12.51C21.3274 12.12 21.0674 11.74 20.6074 11.43C19.7374 10.85 18.4174 10.62 17.1774 10.84C16.7674 10.92 16.3774 10.64 16.3074 10.23C16.2374 9.82002 16.5074 9.43003 16.9174 9.36003C18.5474 9.07003 20.2374 9.38002 21.4374 10.18C22.3174 10.77 22.8274 11.61 22.8274 12.51C22.8274 13.4 22.3274 14.25 21.4374 14.85C20.5274 15.45 19.3474 15.78 18.1174 15.78Z"
        fill="#6D6E7A"
      />
      <path
        d="M6.0774 8.41C6.0674 8.41 6.0574 8.41 6.0574 8.41C4.2574 8.35 2.8474 6.89 2.8374 5.09C2.8374 3.25 4.3374 1.75 6.1674 1.75C7.9974 1.75 9.4974 3.25 9.4974 5.08C9.4974 6.89 8.0874 8.35 6.2874 8.41L6.0774 7.66L6.1474 8.41C6.1274 8.41 6.0974 8.41 6.0774 8.41ZM6.1774 6.91C6.2374 6.91 6.2874 6.91 6.3474 6.92C7.2374 6.88 8.0174 6.08 8.0174 5.09C8.0174 4.08 7.1974 3.25999 6.1874 3.25999C5.1774 3.25999 4.3574 4.08 4.3574 5.09C4.3574 6.07 5.1174 6.86 6.0874 6.92C6.0974 6.91 6.1374 6.91 6.1774 6.91Z"
        fill="#6D6E7A"
      />
      <path
        d="M6.06742 15.78C4.83742 15.78 3.65742 15.45 2.74742 14.85C1.86742 14.26 1.35742 13.41 1.35742 12.51C1.35742 11.62 1.86742 10.77 2.74742 10.18C3.94742 9.38002 5.63742 9.07003 7.26742 9.36003C7.67742 9.43003 7.94742 9.82002 7.87742 10.23C7.80742 10.64 7.41742 10.92 7.00742 10.84C5.76742 10.62 4.45742 10.85 3.57742 11.43C3.10742 11.74 2.85742 12.12 2.85742 12.51C2.85742 12.9 3.11742 13.29 3.57742 13.6C4.44742 14.18 5.74742 14.41 6.97742 14.2C7.38742 14.13 7.77742 14.41 7.84742 14.81C7.91742 15.22 7.64742 15.61 7.23742 15.68C6.84742 15.75 6.45742 15.78 6.06742 15.78Z"
        fill="#6D6E7A"
      />
      <path
        d="M12.1072 15.88C12.0772 15.88 12.0572 15.88 12.0272 15.88H11.9772C10.0872 15.82 8.67725 14.36 8.67725 12.56C8.67725 10.72 10.1772 9.22998 12.0072 9.22998C13.8372 9.22998 15.3372 10.73 15.3372 12.56C15.3272 14.37 13.9172 15.83 12.1172 15.89C12.1172 15.88 12.1172 15.88 12.1072 15.88ZM12.0072 10.72C10.9972 10.72 10.1772 11.54 10.1772 12.55C10.1772 13.54 10.9472 14.34 11.9372 14.38C11.9472 14.37 12.0272 14.37 12.1172 14.38C13.0872 14.33 13.8372 13.53 13.8472 12.55C13.8472 11.55 13.0272 10.72 12.0072 10.72Z"
        fill="#6D6E7A"
      />
      <path
        d="M12.1072 23.26C10.9072 23.26 9.70721 22.95 8.77721 22.32C7.89721 21.73 7.38721 20.89 7.38721 19.99C7.38721 19.1 7.88721 18.24 8.77721 17.65C10.6472 16.41 13.5772 16.41 15.4372 17.65C16.3172 18.24 16.8272 19.08 16.8272 19.98C16.8272 20.87 16.3272 21.73 15.4372 22.32C14.5072 22.94 13.3072 23.26 12.1072 23.26ZM9.60721 18.91C9.13721 19.22 8.88721 19.61 8.88721 20C8.88721 20.39 9.14721 20.77 9.60721 21.08C10.9572 21.99 13.2472 21.99 14.5972 21.08C15.0672 20.77 15.3172 20.38 15.3172 19.99C15.3172 19.6 15.0572 19.22 14.5972 18.91C13.2572 18 10.9672 18.01 9.60721 18.91Z"
        fill="#6D6E7A"
      />
    </svg>
  );
};

export default UserGroupIcon;
